const MoreInformation = () => {
    return (<h2>MoreInformation</h2>)
}

export default MoreInformation